import gql from 'graphql-tag';

import {
  RhythmPointFields,
  rhythmPointFields,
} from '@/queries/fields/rhythmPointFields';
import { Day } from '@/components/pages/schedules/subcomponents/scheduledEventFunctions';

export const rhythmFields = gql`
  fragment rhythmFields on Rhythm {
    id
    floorId
    roomId
    type
    name
    days
    points {
      ...rhythmPointFields
    }
  }
  ${rhythmPointFields}
`;

export type RhythmFields = {
  __typename: 'RhythmFields';
  id: string;
  floorId: string;
  roomId: string;
  type: string;
  name: string;
  days: Day[];
  points: RhythmPointFields[];
};
